/* CELLA — interacciones ligeras, sin dependencias */
(() => {
'use strict';
const KB = window.KB || {};
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
const parallaxFns = [];

const money = (cents) => {
  const fmt = KB.moneyFormat || '{{amount_with_comma_separator}} €';
  const n = Number(cents) / 100;
  const withComma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const withDot = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    if (k === 'amount_with_comma_separator') return withComma;
    if (k === 'amount_no_decimals') return Math.round(n).toString();
    if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return withDot;
  }).replace(/<[^>]*>/g, '');
};

let toastT;
const toast = (msg) => {
  const el = $('.kb-toast'); if (!el) return;
  el.textContent = msg; el.hidden = false;
  requestAnimationFrame(() => el.classList.add('is-in'));
  clearTimeout(toastT);
  toastT = setTimeout(() => { el.classList.remove('is-in'); setTimeout(() => (el.hidden = true), 400); }, 2800);
};

const trap = (container, e) => {
  if (e.key !== 'Tab') return;
  const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container).filter((x) => x.offsetParent !== null);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
};
const lockScroll = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };

/* header */
const header = $('[data-header]');
if (header) {
  let lastY = window.scrollY;
  const onScroll = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 40);
    const anyOpen = header.querySelector('.kb-nav__item.is-open');
    if (!anyOpen && y > 600 && y > lastY + 4) header.classList.add('is-hidden');
    if (y < lastY - 4 || y < 600) header.classList.remove('is-hidden');
    lastY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  $$('[data-dropdown]', header).forEach((item) => {
    const btn = $('button', item);
    let closeT;
    const open = (v) => {
      $$('[data-dropdown].is-open', header).forEach((o) => { if (o !== item) { o.classList.remove('is-open'); $('button', o).setAttribute('aria-expanded', 'false'); } });
      item.classList.toggle('is-open', v); btn.setAttribute('aria-expanded', String(v));
    };
    btn.addEventListener('click', () => open(!item.classList.contains('is-open')));
    if (fine) {
      item.addEventListener('mouseenter', () => { clearTimeout(closeT); open(true); });
      item.addEventListener('mouseleave', () => { closeT = setTimeout(() => open(false), 160); });
    }
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { open(false); btn.focus(); } });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) open(false); });
  });
}

/* mobile menu */
const mobile = $('[data-mobile]');
const burger = $('[data-menu-open]');
if (mobile && burger) {
  const set = (v) => {
    mobile.classList.toggle('is-open', v); mobile.setAttribute('aria-hidden', String(!v));
    burger.setAttribute('aria-expanded', String(v)); lockScroll(v);
    if (v) setTimeout(() => $('[data-menu-close]', mobile).focus(), 50); else burger.focus();
  };
  burger.addEventListener('click', () => set(true));
  $('[data-menu-close]', mobile).addEventListener('click', () => set(false));
  mobile.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); trap(mobile, e); });
}

/* predictive search */
const search = $('[data-search]');
if (search) {
  const openBtn = $('[data-search-open]');
  const input = $('[data-search-input]', search);
  const results = $('[data-search-results]', search);
  const initial = results.innerHTML;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const set = (v) => {
    search.classList.toggle('is-open', v); search.setAttribute('aria-hidden', String(!v));
    openBtn && openBtn.setAttribute('aria-expanded', String(v)); lockScroll(v);
    if (v) setTimeout(() => input.focus(), 80); else openBtn && openBtn.focus();
  };
  openBtn && openBtn.addEventListener('click', () => set(true));
  $('[data-search-close]', search).addEventListener('click', () => set(false));
  search.addEventListener('click', (e) => { if (e.target === search) set(false); });
  search.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); trap(search, e); });
  let t, ctrl;
  input.addEventListener('input', () => {
    clearTimeout(t);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = initial; return; }
    t = setTimeout(async () => {
      try {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        const url = KB.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        const r = await fetch(url, { signal: ctrl.signal });
        if (!r.ok) throw new Error('search');
        const data = await r.json();
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) { results.innerHTML = '<p class="kb-muted">Sin coincidencias para «' + esc(q) + '».</p>'; return; }
        results.innerHTML = '<ul>' + items.map((p) => {
          const title = esc(p.title.replace('SKIN1004 ', ''));
          return '<li><a href="' + esc(p.url) + '"><span class="kb-mega__sym" aria-hidden="true">' + title.slice(0, 2) + '</span><span><b style="font:400 20px/1.1 var(--f-display)">' + title + '</b><br><span class="kb-mono kb-muted">' + esc(p.type || '') + '</span></span><span>' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
        }).join('') + '</ul><p style="margin-top:16px"><a class="kb-link" href="/search?type=product&q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a></p>';
      } catch (err) { if (err.name !== 'AbortError') results.innerHTML = initial; }
    }, 220);
  });
}

/* cart */
const drawer = $('[data-drawer]');
const sectionId = 'kb-cart-drawer';
let lastFocus = null;
const updateCount = (n) => {
  $$('[data-cart-count]').forEach((c) => {
    c.textContent = n; c.classList.toggle('has-items', n > 0);
    c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    const a = c.closest('a'); if (a) a.setAttribute('aria-label', 'Cesta, ' + n + ' artículos');
  });
};
const paintDrawer = (html) => {
  const cur = document.getElementById('shopify-section-' + sectionId);
  if (!cur || !html) return;
  const d = document.createElement('div'); d.innerHTML = html;
  const inner = d.querySelector('#shopify-section-' + sectionId) || d.firstElementChild;
  cur.innerHTML = inner ? inner.innerHTML : d.innerHTML;
};
const openDrawer = () => {
  if (!drawer) { window.location.href = KB.routes.cart; return; }
  lastFocus = document.activeElement;
  drawer.classList.add('is-open'); lockScroll(true);
  setTimeout(() => $('.kb-drawer__panel', drawer).focus(), 60);
};
const closeDrawer = () => {
  if (!drawer || !drawer.classList.contains('is-open')) return;
  drawer.classList.remove('is-open'); lockScroll(false);
  if (lastFocus && lastFocus.focus) lastFocus.focus();
};
const addItems = async (items, btn) => {
  if (btn) btn.classList.add('is-loading');
  try {
    const r = await fetch(KB.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionId, sections_url: window.location.pathname })
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'No se pudo añadir');
    if (data.sections) paintDrawer(data.sections[sectionId]);
    const cart = await fetch(KB.routes.cart + '.js').then((x) => x.json());
    updateCount(cart.item_count);
    openDrawer();
    return true;
  } catch (err) {
    toast(err.message || 'No se pudo añadir a la cesta');
    return false;
  } finally { if (btn) btn.classList.remove('is-loading'); }
};
const changeLine = async (line, quantity) => {
  const row = drawer && $('[data-line="' + line + '"]', drawer);
  if (row) row.classList.add('is-busy');
  try {
    const r = await fetch(KB.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: sectionId, sections_url: window.location.pathname })
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || 'No se pudo actualizar');
    updateCount(data.item_count);
    if (data.sections) paintDrawer(data.sections[sectionId]);
    const close = $('[data-drawer-close]', drawer); if (close && drawer.classList.contains('is-open')) close.focus();
  } catch (err) { toast(err.message); if (row) row.classList.remove('is-busy'); }
};

document.addEventListener('click', (e) => {
  const t = e.target;
  const cartOpen = t.closest('[data-cart-open]');
  if (cartOpen && drawer && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); openDrawer(); return; }
  if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
  const lq = t.closest('[data-line-qty]');
  if (lq) { changeLine(lq.dataset.lineQty, lq.dataset.qty); return; }
  const qa = t.closest('[data-quick-add]');
  if (qa) { e.preventDefault(); addItems([{ id: Number(qa.dataset.quickAdd), quantity: 1 }], qa); return; }
  const many = t.closest('[data-add-many]');
  if (many && many.dataset.addMany) {
    const ids = many.dataset.addMany.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    addItems(ids, many);
  }
});
document.addEventListener('change', (e) => {
  const inp = e.target.closest('[data-line-input]');
  if (inp) changeLine(inp.dataset.lineInput, inp.value);
});
if (drawer) drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); trap($('.kb-drawer__panel', drawer), e); });

/* qty steppers */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-qty-step]'); if (!b) return;
  const input = $('[data-qty-input]', b.parentElement); if (!input) return;
  const min = Number(input.min || 0), max = Number(input.max || 99);
  input.value = Math.min(max, Math.max(min, (Number(input.value) || 0) + Number(b.dataset.qtyStep)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
$$('[data-autosubmit]').forEach((i) => { let t; i.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => i.form.submit(), 450); }); });

/* product form */
const pf = $('[data-product-form]');
if (pf) {
  const variants = JSON.parse($('[data-variants]', pf).textContent);
  const idInput = $('[data-variant-id]', pf);
  const addBtn = $('[data-add-btn]', pf);
  const addLabel = $('[data-add-label]', pf);
  const priceEls = $$('[data-price]');
  const avail = $('[data-availability]');
  const current = () => variants.find((v) => String(v.id) === idInput.value);
  const sync = () => {
    const opts = $$('[data-option]:checked', pf).sort((a, b) => a.dataset.option - b.dataset.option).map((i) => i.value);
    const v = variants.find((x) => x.options.every((o, i) => opts[i] === undefined || o === opts[i]));
    if (!v) { addBtn.disabled = true; addLabel.textContent = 'No disponible'; return; }
    idInput.value = v.id;
    priceEls.forEach((p) => (p.textContent = money(v.price)));
    addBtn.disabled = !v.available;
    addLabel.textContent = v.available ? 'Añadir a la cesta' : 'Agotado';
    if (avail) avail.textContent = v.available ? 'Disponible para pedidos de prueba' : 'No disponible';
    const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  };
  $$('[data-option]', pf).forEach((i) => i.addEventListener('change', sync));
  pf.addEventListener('submit', (e) => {
    e.preventDefault();
    const qty = Math.max(1, Number($('[data-qty-input]', pf).value) || 1);
    addItems([{ id: Number(idInput.value), quantity: qty }], addBtn);
  });
  const sticky = $('[data-sticky-buy]');
  if (sticky && 'IntersectionObserver' in window) {
    const sAdd = $('[data-sticky-add]', sticky);
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
      sAdd.tabIndex = show ? 0 : -1;
    }).observe(addBtn);
    sAdd.addEventListener('click', () => {
      const v = current();
      if (!v || !v.available) return;
      addItems([{ id: v.id, quantity: 1 }], sAdd);
    });
  }
}

/* collection filters */
const fr = $('[data-filters-root]');
const grid = $('[data-grid]');
if (fr && grid) {
  const panel = $('#kb-filters');
  const toggle = $('[data-filter-toggle]', fr);
  const countEl = $('[data-results-count]', fr);
  const fCount = $('[data-filter-count]', fr);
  const sortSel = $('[data-sort]', fr);
  const empty = $('[data-empty]');
  const cards = $$('[data-card]', grid);
  const stepOrder = { limpieza1: 1, limpieza2: 2, tonico: 3, serum: 4, tratamiento: 5, mascarilla: 6, crema: 7, solar: 8 };
  toggle.addEventListener('click', () => { const v = panel.hidden; panel.hidden = !v; toggle.setAttribute('aria-expanded', String(v)); });
  const read = (name) => $$('input[name="' + name + '"]:checked', panel).map((i) => i.value);
  const apply = () => {
    const needs = read('need'), skins = read('skin'), steps = read('step');
    let shown = 0;
    cards.forEach((c) => {
      const cn = c.dataset.needs.split(' '), cs = c.dataset.skins.split(' ');
      const ok = (!needs.length || needs.some((n) => cn.includes(n))) && (!skins.length || skins.some((s) => cs.includes(s))) && (!steps.length || steps.includes(c.dataset.step));
      c.classList.toggle('is-hidden', !ok);
      if (ok) { shown++; c.classList.add('is-in'); }
    });
    const active = needs.length + skins.length + steps.length;
    fCount.textContent = active ? '(' + active + ')' : '';
    countEl.textContent = shown + ' producto' + (shown === 1 ? '' : 's');
    if (empty) empty.hidden = shown > 0;
    const params = new URLSearchParams(window.location.search);
    ['need', 'skin', 'step'].forEach((k) => params.delete(k));
    needs.forEach((v) => params.append('need', v)); skins.forEach((v) => params.append('skin', v)); steps.forEach((v) => params.append('step', v));
    const qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  };
  const sorters = {
    index: (a, b) => a.dataset.index - b.dataset.index,
    'price-asc': (a, b) => a.dataset.price - b.dataset.price,
    'price-desc': (a, b) => b.dataset.price - a.dataset.price,
    'title-asc': (a, b) => a.dataset.title.localeCompare(b.dataset.title, 'es'),
    step: (a, b) => (stepOrder[a.dataset.step] || 9) - (stepOrder[b.dataset.step] || 9)
  };
  panel.addEventListener('change', apply);
  sortSel.addEventListener('change', () => { cards.slice().sort(sorters[sortSel.value]).forEach((c) => grid.appendChild(c)); });
  $$('[data-filter-clear]').forEach((b) => b.addEventListener('click', () => { $$('input:checked', panel).forEach((i) => (i.checked = false)); apply(); }));
  const params = new URLSearchParams(window.location.search);
  let any = false;
  ['need', 'skin', 'step'].forEach((n) => params.getAll(n).forEach((v) => { $$('input[name="' + n + '"]', panel).forEach((i) => { if (i.value === v) { i.checked = true; any = true; } }); }));
  if (any) { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); apply(); }
}

/* rails */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-rail-prev],[data-rail-next]'); if (!b) return;
  const rail = document.getElementById(b.dataset.railPrev || b.dataset.railNext); if (!rail) return;
  const card = rail.firstElementChild; const w = card ? card.getBoundingClientRect().width + 20 : 300;
  rail.scrollBy({ left: (b.dataset.railPrev ? -1 : 1) * w * 2, behavior: reduce ? 'auto' : 'smooth' });
});

/* tabs */
$$('[data-tabs]').forEach((root) => {
  const tabs = $$('[role="tab"]', root);
  const select = (tab) => {
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; t.classList.toggle('is-active', on);
      const p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) { p.hidden = !on; if (on) $$('[data-reveal]', p).forEach((r) => r.classList.add('is-in')); }
    });
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => select(t));
    t.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); select(n);
      }
    });
  });
});

/* reveal */
const reveals = $$('[data-reveal]');
if ('IntersectionObserver' in window && !reduce) {
  const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  reveals.forEach((r) => io.observe(r));
} else reveals.forEach((r) => r.classList.add('is-in'));

/* manifesto words */
$$('[data-split]').forEach((el) => {
  const words = el.textContent.trim().split(/\s+/);
  el.innerHTML = words.map((w) => '<span class="w">' + w + '</span>').join(' ');
  const ws = $$('.w', el);
  if (reduce) { ws.forEach((w) => w.classList.add('is-lit')); return; }
  parallaxFns.push(() => {
    const r = el.getBoundingClientRect(), vh = window.innerHeight;
    const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
    const lit = Math.round(p * ws.length);
    ws.forEach((w, i) => w.classList.toggle('is-lit', i < lit));
  });
});

/* count up */
if ('IntersectionObserver' in window && !reduce) {
  const cio = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting) return;
    const el = en.target, to = Number(el.dataset.count); cio.unobserve(el);
    if (!to) return;
    const t0 = performance.now(), dur = 1400;
    const step = (now) => { const k = Math.min(1, (now - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }), { threshold: 0.6 });
  $$('[data-count]').forEach((el) => cio.observe(el));
}

/* parallax */
const pEls = reduce ? [] : $$('[data-parallax]');
let ticking = false;
const runParallax = () => {
  const vh = window.innerHeight;
  pEls.forEach((el) => {
    const host = el.closest('section') || el.parentElement || el;
    const r = host.getBoundingClientRect();
    if (r.bottom < -200 || r.top > vh + 200) return;
    const speed = parseFloat(el.dataset.parallax) || 0;
    const center = r.top + r.height / 2 - vh / 2;
    el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
  });
  parallaxFns.forEach((f) => f());
  ticking = false;
};
const onScrollP = () => { if (!ticking) { ticking = true; requestAnimationFrame(runParallax); } };
if (pEls.length || parallaxFns.length) { window.addEventListener('scroll', onScrollP, { passive: true }); window.addEventListener('resize', onScrollP); runParallax(); }

/* pointer glow + magnetic */
if (fine && !reduce) {
  document.addEventListener('pointermove', (e) => {
    const t = e.target.closest && e.target.closest('.kb-btn, [data-glow], .kb-el');
    if (!t) return;
    const r = t.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
    t.style.setProperty('--mx', x + '%'); t.style.setProperty('--my', y + '%');
    if (t.classList.contains('kb-el')) { t.style.setProperty('--ox', x + '%'); t.style.setProperty('--oy', y + '%'); }
  }, { passive: true });
  $$('[data-magnetic]').forEach((b) => {
    b.addEventListener('pointermove', (e) => {
      const r = b.getBoundingClientRect();
      b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.12).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.2).toFixed(1) + 'px)';
    });
    b.addEventListener('pointerleave', () => (b.style.transform = ''));
  });
}

/* routine finder */
const finder = $('[data-finder]');
if (finder) {
  const form = $('[data-finder-form]', finder);
  const products = JSON.parse($('[data-finder-products]', finder).textContent).filter((p) => p.available);
  const qs = $$('[data-q]', form);
  const result = $('[data-result]', form);
  const progress = $$('[data-prog]', finder);
  let step = 1;
  const show = (n) => {
    step = n;
    qs.forEach((q) => (q.hidden = Number(q.dataset.q) !== n));
    result.hidden = n !== 4;
    progress.forEach((p) => p.classList.toggle('is-done', Number(p.dataset.prog) < n || n === 4));
    const target = n === 4 ? result : $('[data-q="' + n + '"] legend', form);
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    const top = form.getBoundingClientRect().top + window.scrollY - 120;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  };
  const validate = () => {
    qs.forEach((q) => { const n = $('[data-next]', q); if (n) n.disabled = $$('input:checked', q).length === 0; });
    const boxes = $$('input[name="need"]', form);
    const checked = boxes.filter((b) => b.checked).length;
    boxes.forEach((b) => { if (!b.checked) b.disabled = checked >= 2; });
  };
  form.addEventListener('change', validate);
  form.addEventListener('click', (e) => {
    const nx = e.target.closest('[data-next]');
    if (nx && nx.type !== 'submit') show(step + 1);
    if (e.target.closest('[data-prev]')) show(step - 1);
    if (e.target.closest('[data-restart]')) { form.reset(); validate(); show(1); }
  });
  const labels = { calma: 'calma', hidratacion: 'hidratación', luminosidad: 'luminosidad', poros: 'poros', imperfecciones: 'imperfecciones', barrera: 'barrera', firmeza: 'firmeza', textura: 'textura' };
  const skinLabels = { seca: 'piel seca', normal: 'piel normal', mixta: 'piel mixta', grasa: 'piel grasa', sensible: 'piel sensible' };
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const skin = (form.querySelector('input[name="skin"]:checked') || {}).value;
    const needs = $$('input[name="need"]:checked', form).map((i) => i.value);
    const length = (form.querySelector('input[name="length"]:checked') || {}).value;
    const steps = length === 'complete' ? ['limpieza1', 'limpieza2', 'tonico', 'serum', 'crema', 'solar'] : ['limpieza2', 'serum', 'crema', 'solar'];
    if (length === 'complete') {
      if (needs.includes('poros') || needs.includes('textura')) steps.splice(5, 0, 'mascarilla');
      if (needs.includes('imperfecciones')) steps.splice(5, 0, 'tratamiento');
    }
    const picks = [];
    steps.forEach((s) => {
      const cands = products.filter((p) => p.step === s && picks.indexOf(p) === -1);
      if (!cands.length) return;
      const score = (p) => p.needs.filter((n) => needs.includes(n)).length * 3 + (p.skins.includes(skin) ? 2 : 0) - p.price / 100000;
      cands.sort((a, b) => score(b) - score(a));
      picks.push(cands[0]);
    });
    $('[data-result-list]', result).innerHTML = picks.map((p, i) => {
      const why = p.needs.filter((n) => needs.includes(n)).map((n) => labels[n]);
      if (p.skins.includes(skin)) why.push(skinLabels[skin]);
      return '<li class="kb-step"><span class="kb-step__n">0' + (i + 1) + '</span><a href="' + p.url + '" tabindex="-1" aria-hidden="true"><div class="kb-spec" style="--hue:' + p.hue + '"><div class="kb-spec__sym">' + p.sym + '</div></div></a><span class="kb-step__t"><span>' + (p.stepLabel || '') + '</span><a href="' + p.url + '"><b>' + p.title + '</b></a><span>' + p.line + ' · ' + p.size + (why.length ? ' · encaja con: ' + why.join(', ') : ' · paso básico de la rutina') + '</span></span><span class="kb-step__p">' + money(p.price) + '</span></li>';
    }).join('');
    const total = picks.reduce((a, p) => a + p.price, 0);
    $('[data-result-title]', result).textContent = 'Rutina ' + (length === 'complete' ? 'completa' : 'esencial') + ' para ' + (skinLabels[skin] || 'tu piel') + (needs.length ? ', con foco en ' + needs.map((n) => labels[n]).join(' y ') : '') + '.';
    $('[data-result-total]', result).textContent = money(total);
    $('[data-result-count]', result).textContent = picks.length + ' productos · formato más pequeño';
    $('[data-add-many]', result).dataset.addMany = picks.map((p) => p.variant).join(',');
    show(4);
  });
  validate();
}
})();
